<hrt-tab
  [hasTabs]="true"
  [title]="'Dashboard'"
  [tabs]="dashboardTabs"
  [renderAllTabs]="false"
  [selectedIndex]="selectedTabIndex"
></hrt-tab>
